export default {
  common: {
    required: '该项为必填项',
    loginOut: '退出系统',
    document: '项目文档',
    reminder: '温馨提示',
    loginOutMessage: '是否退出本系统？',
    ok: '确定',
    cancel: '取消',
    reload: '重新加载',
    closeTab: '关闭标签页',
    closeTheLeftTab: '关闭左侧标签页',
    closeTheRightTab: '关闭右侧标签页',
    closeOther: '关闭其它标签页',
    closeAll: '关闭全部标签页',
    scrollTagsLeft: '向左滚动标签页',
    scrollTagsRight: '向右滚动标签页',
    moreTabActions: '更多标签页操作',
    search: '查询',
    reset: '重置',
    create: '新建',
    edit: '编辑',
    delete: '删除',
    actions: '操作',
    confirm: '确定',
    confirmDelete: '确定要删除 {name} 吗？',
    submit: '提交',
    submitSuccess: '操作成功',
    submitFailed: '操作失败',
    loading: '加载中...',
    noData: '暂无数据',
    refresh: '刷新',
    selected: '已选 {count} 项',
    close: '关闭'
  },
  picker: {
    checkedCount: '已选 {count} 项'
  },
  error: {
    pageError: '抱歉，您访问的页面不存在。',
    returnToHome: '返回首页'
  },
  layout: {
    title: '页面布局',
    hint: '选择后立即生效',
    switch: '切换页面布局',
    sidebar: '经典侧边栏',
    top: '顶部导航',
    mixed: '混合导航',
    dual: '双列侧边栏',
    expandNavigation: '展开导航菜单',
    collapseNavigation: '收起导航菜单'
  },
  login: {
    welcome: '欢迎使用本系统',
    message: '开箱即用的中后台管理系统',
    username: '用户名',
    password: '密码',
    register: '注册',
    checkPassword: '确认密码',
    login: '登录',
    remember: '记住我',
    hasUser: '已有账号？去登录',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    code: '验证码',
    codePlaceholder: '请输入验证码',
    getCode: '获取验证码',
    passwordMismatch: '两次输入的密码不一致',
    agreement: '我同意《用户协议》',
    agreementRequired: '请先同意用户协议',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    phoneLength: '手机号长度需在 6-20 位之间',
    passwordLength: '密码长度需在 6-128 位之间',
    failed: '登录失败，请检查手机号与密码'
  },
  router: {
    login: '登录',
    dashboard: '首页',
    level: '多级菜单',
    menu1: '菜单1',
    menu11: '菜单1-1',
    menu111: '菜单1-1-1',
    menu12: '菜单1-2',
    menu2: '菜单2',
    system: '系统管理',
    systemUsers: '用户管理',
    systemRoles: '角色管理',
    systemPermissions: '权限码管理',
    teaching: '教学管理',
    teachingCourses: '课程管理',
    teachingSkills: '技能管理',
    teachingAssets: '教学资料',
    qa: '答疑管理',
    qaRecords: '答疑记录'
  },
  resource: {
    codePattern: '请使用小写字母、数字与下划线，且必须包含一个点（形如 aaa.bbb）'
  },
  permission: {
    code: '权限码',
    name: '名称',
    description: '描述',
    keywordPlaceholder: '按 code 或 name 模糊查询',
    codePlaceholder: '形如 user.read',
    namePlaceholder: '请输入名称',
    descriptionPlaceholder: '请输入描述（选填）',
    create: '新建权限码',
    edit: '编辑权限码'
  },
  role: {
    code: '角色编码',
    name: '角色名称',
    description: '描述',
    builtin: '内置',
    builtinTip: '内置角色不可编辑/删除',
    assignPermissions: '分配权限',
    keywordPlaceholder: '按 code 或 name 模糊查询',
    permissionCodes: '权限码',
    create: '新建角色',
    edit: '编辑角色',
    roleId: '角色 ID',
    roleList: '角色列表'
  },
  userRole: {
    title: '用户角色',
    userId: '用户 ID',
    userIdRequired: '请先输入用户 ID',
    roleNames: '已分配角色',
    permissionCodes: '已聚合权限码',
    assignRole: '分配角色',
    noData: '请先输入用户 ID 并查询'
  },
  user: {
    username: '用户名',
    usernamePlaceholder: '1-64 个字符',
    usernameLength: '用户名长度需在 1-64 位之间',
    password: '密码',
    passwordPlaceholder: '6-128 个字符',
    newPassword: '新密码',
    phone: '手机号',
    phonePlaceholder: '请输入手机号（选填）',
    nickname: '昵称',
    nicknamePlaceholder: '请输入昵称（选填）',
    businessRole: '业务角色',
    businessRolePlaceholder: '请选择业务角色',
    isAdmin: '后台管理员',
    isAdminHint: '允许登录后台',
    isAdminAllow: '允许',
    isAdminDeny: '禁止',
    roleSuperAdmin: '超管',
    roleTeacher: '教师',
    roleStudent: '学生',
    isAdminFilter: '仅管理员',
    keywordPlaceholder: '按用户名/手机号/昵称模糊查询',
    create: '新建用户',
    edit: '编辑用户',
    resetPassword: '重置密码',
    deleteSelfForbidden: '不能删除当前登录用户',
    confirmDelete: '确定要删除用户 {name} 吗？'
  },
  profile: {
    title: '个人信息',
    userId: '用户 ID',
    username: '姓名',
    nickname: '昵称',
    phone: '手机号',
    changePassword: '修改密码',
    oldPassword: '原密码',
    oldPasswordPlaceholder: '若未设密码可留空',
    newPassword: '新密码',
    newPasswordPlaceholder: '6-128 个字符',
    confirmPassword: '确认新密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    passwordMismatch: '两次输入的新密码不一致',
    passwordChanged: '密码修改成功'
  },
  course: {
    title: '课程管理',
    name: '课程名称',
    namePlaceholder: '请输入课程名称',
    nameLength: '课程名称长度需在 1-128 位之间',
    subject: '学科',
    subjectPlaceholder: '请选择学科',
    gradeScope: '适用年级',
    gradeScopePlaceholder: '可多选（不选视为全部）',
    gradeScopePattern: '年级范围格式错误，应为 X-Y 且 1≤X≤Y≤12',
    gradesRequired: '请至少选择一个适用年级',
    description: '简介',
    descriptionPlaceholder: '200 字以内',
    descriptionLength: '简介不能超过 200 字',
    status: '状态',
    statusPlaceholder: '请选择状态',
    sortOrder: '排序',
    sortOrderPlaceholder: '同级排序升序，数字越小越靠前',
    parent: '父级课程',
    parentPlaceholder: '不选则为根课程',
    parentNone: '（根课程）',
    createRoot: '新增根课程',
    addChild: '新增子课程',
    addSibling: '新增同级课程',
    changeParent: '修改父课程',
    changeSort: '修改排序',
    changeStatus: '停用',
    enableStatus: '启用',
    subjectAll: '全部学科',
    statusAll: '全部状态',
    statusDraft: '草稿',
    statusTrial: '试用',
    statusActive: '已发布',
    statusInactive: '已停用',
    cascadeTip: '停用该课程会级联停用全部后代',
    deleteCascadeTip: '删除该课程会级联删除（软删）全部后代',
    confirmDeleteCascade: '确定删除「{name}」及其全部后代吗？此操作不可撤销。',
    hasChildren: '该课程下存在 {count} 个子课程',
    setSkills: '设置技能',
    setSkillsTitle: '为「{name}」设置关联技能',
    setSkillsHint: '勾选要关联到本课程的技能（整体替换已关联项）',
    skillsKeywordPlaceholder: '按技能名称搜索'
  },
  skill: {
    title: '技能管理',
    name: '技能名称',
    namePlaceholder: '请输入技能名称',
    nameLength: '技能名称长度需在 1-128 位之间',
    subject: '学科',
    subjectPlaceholder: '请选择学科',
    module: '所属模块',
    modulePlaceholder: '20 字以内，可留空',
    description: '说明',
    descriptionPlaceholder: '200 字以内',
    descriptionLength: '说明不能超过 200 字',
    status: '状态',
    statusPlaceholder: '请选择状态',
    sortOrder: '排序',
    sortOrderPlaceholder: '同级排序升序，数字越小越靠前',
    parent: '父级技能',
    parentPlaceholder: '不选则为根技能',
    parentNone: '（根技能）',
    createRoot: '新增根技能',
    addChild: '新增子技能',
    addSibling: '新增同级技能',
    changeParent: '修改父技能',
    changeSort: '修改排序',
    changeStatus: '停用',
    enableStatus: '启用',
    subjectAll: '全部学科',
    statusAll: '全部状态',
    statusDraft: '草稿',
    statusTrial: '试用',
    statusActive: '已发布',
    statusInactive: '已停用',
    cascadeTip: '停用该技能会级联停用全部后代',
    deleteCascadeTip: '删除该技能会级联删除（软删）全部后代',
    confirmDeleteCascade: '确定删除「{name}」及其全部后代吗？此操作不可撤销。',
    hasChildren: '该技能下存在 {count} 个子技能',
    setCourses: '设置课程',
    setCoursesTitle: '为「{name}」设置关联课程',
    setCoursesHint: '勾选要关联到本技能的课程（整体替换已关联项）',
    coursesKeywordPlaceholder: '按课程名称搜索'
  },
  analysis: {
    newUser: '新增用户',
    unreadInformation: '未读消息',
    transactionAmount: '成交金额',
    totalShopping: '购物总量',
    monthlySales: '每月销售额',
    userAccessSource: '用户访问来源',
    january: '一月',
    february: '二月',
    march: '三月',
    april: '四月',
    may: '五月',
    june: '六月',
    july: '七月',
    august: '八月',
    september: '九月',
    october: '十月',
    november: '十一月',
    december: '十二月',
    estimate: '预计',
    actual: '实际',
    directAccess: '直接访问',
    mailMarketing: '邮件营销',
    allianceAdvertising: '联盟广告',
    videoAdvertising: '视频广告',
    searchEngines: '搜索引擎',
    weeklyUserActivity: '每周用户活跃量',
    activeQuantity: '活跃量',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日'
  },
  levelDemo: {
    menu: '多级菜单缓存'
  },
  asset: {
    title: '教学资料',
    name: '资料名称',
    assetType: '资料类型',
    assetTypeAll: '全部资料类型',
    assetTypePlaceholder: '请选择资料类型',
    fileType: '文件类型',
    fileTypeAll: '全部文件类型',
    fileTypePlaceholder: '请选择文件类型',
    status: '状态',
    statusAll: '全部状态',
    statusPlaceholder: '请选择状态',
    nameKeyword: '关键词',
    nameKeywordPlaceholder: '按资料名称模糊搜索',
    dateRange: '上传时间',
    fileSize: '大小',
    fileSizeBytes: '{size} 字节',
    originalFilename: '原文件名',
    uploadedAt: '上传时间',
    description: '说明',
    descriptionPlaceholder: '200 字以内',
    create: '新建资料',
    edit: '编辑资料',
    upload: '上传资料',
    bulkUpload: '批量上传',
    bulkUploadHint: '选择多个文件，批量入库为同一资料类型',
    bulkChangeStatus: '批量改状态',
    changeStatus: '停用',
    enableStatus: '启用',
    download: '下载',
    detail: '查看详情',
    delete: '删除',
    deleteConfirm: '确定要删除「{name}」吗？',
    deleteCascadeTip: '此操作不可撤销',
    selectFiles: '选择文件',
    fileChosen: '已选择 {count} 个文件',
    noFileChosen: '尚未选择文件',
    submitHint: '提交后将以当前所选资料类型与状态入库',
    assetTypesLoading: '资料类型加载中…',
    setCourses: '设置课程',
    setSkills: '设置能力',
    bulkSetCourses: '批量设置课程',
    bulkSetSkills: '批量设置能力',
    setCoursesTitle: '为「{name}」设置课程',
    setSkillsTitle: '为「{name}」设置能力',
    bulkSetCoursesTitle: '为 {count} 条资料设置课程',
    bulkSetSkillsTitle: '为 {count} 条资料设置能力',
    assignHint: '整体替换：仅保留勾选项，全部取消即清空',
    statusDraft: '草稿',
    statusTrial: '试用',
    statusActive: '已发布',
    statusInactive: '已停用',
    cascadeTip: '停用该资料会立即生效（不会级联）'
  },
  qa: {
    title: '答疑记录',
    dateRange: '会话时间',
    userName: '用户姓名',
    userNamePlaceholder: '按昵称 / 用户名模糊搜索',
    sessionTitle: '会话标题',
    sessionTitlePlaceholder: '按会话标题模糊搜索',
    user: '用户',
    messageCount: '消息数',
    createdAt: '创建时间',
    lastActiveAt: '最近活跃',
    detail: '查看详情',
    empty: '暂无答疑记录',
    detailTitle: '答疑会话详情',
    untitled: '（无标题）',
    roleUser: '学生',
    roleAssistant: 'AI 助手',
    roleSystem: '系统',
    kbRefs: '引用知识库',
    kbRefUnknown: '未知文档',
    kbRefNoSummary: '（无引用摘要）',
    noMessages: '该会话暂无消息'
  }
}
